const About = () => {
  return (
    <section className="py-12 container mx-auto px-10">
      {/* <h2 className="text-3xl font-bold text-center mb-8">About Us</h2> */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        
        {/* Image on the left */}
        <div className="px-4">
          <img
            src="/images/gym_2.jpg"
            alt="Gym Interior"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>

        {/* Text on the right */}
        <div className="px-8">
          <p className="text-lg text-gray-700 text-justify font-bebas">
            Power & Pump Fitness Forge is dedicated to helping you achieve your fitness goals with
            state-of-the-art equipment and expert trainers. Our mission is to
            provide a welcoming environment for everyone, from beginners to
            advanced athletes, with personalized plans and top-notch facilities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
